import request from '@/utils/request'

export function courseAgeStatistic(courseId) {
  return request({
    url: `/statistics/course-age?course_id=${courseId}`,
    method: 'get'
  })
}

export function courseGenderStatistic(courseId) {
  return request({
    url: `/statistics/course-gender?course_id=${courseId}`,
    method: 'get'
  })
}

export function courseProgressStatistic(courseId) {
  return request({
    url: `/statistics/course-progress?course_id=${courseId}`,
    method: 'get'
  })
}

export function studentReport(courseId, userId) {
  return request({
    url: `/statistics/student-report?course_id=${courseId}&user_id=${userId}`,
    method: 'get'
  })
}
